/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerlinks1Inputs */

const en_organizerlinks1 = /** @type {(inputs: Organizerlinks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links`)
};

const de_organizerlinks1 = /** @type {(inputs: Organizerlinks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links`)
};

/**
* | output |
* | --- |
* | "Links" |
*
* @param {Organizerlinks1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerlinks1 = /** @type {((inputs?: Organizerlinks1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerlinks1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerlinks1(inputs)
	return de_organizerlinks1(inputs)
});
export { organizerlinks1 as "organizerLinks" }